<template>
  <modal
    ref="uploadFileError"
    title="Aviso"
    template="question"
    ref-name="uploadFileError"
    first-button-text="VOLTAR"
    :icon-enabled="false"
    second-button-text="IR PARA POSTOS DE COLETA"
    :close-button-enabled="false"
    :first-button-disabled="false"
    :second-button-disabled="false"
    class="upload-file-error"
    @first-cta="closeModal()"
    @second-cta="handleSecondButton()"
  >
    <div class="alert-msg">
      <span>Não foi possível importar o seu arquivo</span>
    </div>
    <div class="feedback-content">
      Seu arquivo possui postos de coleta que
      <b>não estão cadastrados no AOL 2.0</b>. Siga os passos para corrigir o
      problema:
      <ul class="custom-list">
        <li>
          <span class="num-list">1.</span>
          <span>Confira os <b>postos de coleta</b> cadastrados no AOL 2.0 e os que
            estão no seu sistema de origem.</span>
        </li>
        <li>
          <span class="num-list">2.</span>
          <span><b>Adicione</b> os postos de coleta que faltam no AOL 2.0.</span>
        </li>
        <li>
          <span class="num-list">3.</span>
          <span>Corrija os dados do seu arquivo e o <b>importe novamente</b>.</span>
        </li>
      </ul>
    </div>
  </modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UploadFileErrorModal',
  methods: {
    ...mapActions(['setIsUploadModalError']),
    handleSecondButton () {
      this.closeModal()
      this.$router.push('/collection-point-management')
    },
    openModal () {
      this.$refs.uploadFileError.open()
    },
    closeModal () {
      this.$refs.uploadFileError.close()
      this.setIsUploadModalError(false)
    }
  },
  watch: {
    isUploadFileModalErrorVisible () {
      if (this.isUploadFileModalErrorVisible) {
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  },
  computed: {
    ...mapGetters(['isUploadFileModalErrorVisible'])
  }
}
</script>

<style lang="scss">
.upload-file-error {
  .md-dialog {
    max-width: 580px;
    .md-dialog-title {
      .standard-modal {
        &__title {
          &::before {
            content: "";
            width: 17px;
            height: 17px;
            background-image: url("/static/images/alert-icon.svg");
            position: relative;
            top: 2px;
            margin-right: 10px;
          }
        }
      }
    }
    .md-dialog-content {
      .standard-modal {
        &__description {
          .alert-msg {
            border-radius: 5px;
            padding: 10px;
            text-align: center;
            background-color: #fdedd3;
            margin-bottom: 12px;
            span {
              letter-spacing: 0;
              color: #4a4a4a;
              &::before {
                display: inline-block;
                content: "";
                width: 17px;
                height: 17px;
                background-image: url("/static/images/alert-icon.svg");
                position: relative;
                top: 3px;
                margin-right: 7px;
              }
            }
          }
          .feedback-content {
            color: #4a4a4a;
            b {
              color: #7f1a54;
            }
            .custom-list {
              margin: 15px 0 0px;
              li {
                display: flex;
                span {
                  letter-spacing: 0;
                  width: calc(100% - 20px);
                }
                .num-list {
                  font-size: 20px;
                  font-weight: bold;
                  color: #b8b7bf;
                  width: 25px;
                  line-height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
